var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.modules,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("new_f"),
                    disable: !_vm.managerTrainings
                  },
                  on: {
                    click: function($event) {
                      return _vm.showModuleModal(0)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "title", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.title) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "group_training_module_type",
                      attrs: { props: props }
                    },
                    [
                      _c("q-icon", {
                        attrs: {
                          name: _vm.getIconName(
                            props.row.group_training_module_type
                          ),
                          size: "1.2rem"
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              _vm.getModuleType(
                                props.row.group_training_module_type
                              )
                            )
                          ) +
                          "\n            "
                      )
                    ],
                    1
                  ),
                  _c("q-td", { key: "qty_views", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.qty_views) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("q-td", { key: "avaliable_in", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.avaliable_in) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "module_score", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.module_score) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "far fa-pencil-alt",
                            disable: !_vm.managerTrainings
                          },
                          on: {
                            click: function($event) {
                              return _vm.showModuleModal(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt",
                            disable: !_vm.managerTrainings
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_trainings" })
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.clearModuleModal()
            }
          },
          model: {
            value: _vm.module_modal,
            callback: function($$v) {
              _vm.module_modal = $$v
            },
            expression: "module_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.module_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("module")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-12" }),
                  _c(
                    "div",
                    {
                      class:
                        _vm.id_module === 0
                          ? "col-xs-10 col-sm-10"
                          : "col-xs-12 col-sm-12"
                    },
                    [
                      _c("q-select", {
                        attrs: {
                          disable:
                            (_vm.qty_views > 0 || _vm.qty_progress > 0) &&
                            _vm.getContentType === "video",
                          options: _vm.moduleTypes,
                          "float-label": _vm.$t("content_type"),
                          error: _vm.$v.group_training_module_type.$error,
                          "display-value": _vm.selectedModuleType
                        },
                        on: { input: _vm.$v.group_training_module_type.$touch },
                        model: {
                          value: _vm.group_training_module_type,
                          callback: function($$v) {
                            _vm.group_training_module_type = $$v
                          },
                          expression: "group_training_module_type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.id_module === 0
                    ? _c(
                        "div",
                        { staticClass: "col-xs-2 col-sm-2 self-end" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              small: "",
                              label: _vm.$t("import_modules_database")
                            },
                            on: {
                              click: function($event) {
                                return _vm.showClassesDataBaseModal()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-field",
                        { attrs: { count: 256 } },
                        [
                          _c("q-input", {
                            attrs: {
                              "float-label": _vm.$t("title"),
                              error: _vm.$v.title.$error
                            },
                            on: { input: _vm.$v.title.$touch },
                            model: {
                              value: _vm.title,
                              callback: function($$v) {
                                _vm.title = $$v
                              },
                              expression: "title"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.showUploader
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6" },
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("file")))
                          ]),
                          _c("uploader", {
                            attrs: {
                              content_type: _vm.getContentType,
                              disable:
                                (_vm.qty_views > 0 ||
                                  (_vm.qty_progress > 0 &&
                                    _vm.id_module !== 0)) &&
                                _vm.getContentType === "video",
                              multiple: false,
                              cropper: false,
                              error: _vm.$v.file_url.$error
                            },
                            on: {
                              fileUploaded: _vm.fileUploaded,
                              input: _vm.$v.file_url.$touch
                            }
                          }),
                          _vm.file_url
                            ? _c(
                                "p",
                                { staticClass: "q-mt-md file-url" },
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      name: "fal fa-check",
                                      color: "positive"
                                    }
                                  }),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.file_complete_url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$truncateLink(_vm.file_url)
                                          )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showUploader
                    ? _c("div", { staticClass: "col-sm-6" })
                    : _vm._e(),
                  _vm.showEmbed
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c(
                            "q-field",
                            { attrs: { helper: _vm.$t("embed_help") } },
                            [
                              _c("q-input", {
                                attrs: {
                                  "float-label": _vm.$t("embed"),
                                  error: _vm.$v.embed.$error
                                },
                                on: { input: _vm.$v.embed.$touch },
                                model: {
                                  value: _vm.embed,
                                  callback: function($$v) {
                                    _vm.embed = $$v
                                  },
                                  expression: "embed"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("q-datetime", {
                        attrs: {
                          type: "date",
                          "float-label": _vm.$t("avaliable_in"),
                          format: "DD/MM/YYYY",
                          clearable: ""
                        },
                        model: {
                          value: _vm.avaliable_in,
                          callback: function($$v) {
                            _vm.avaliable_in = $$v
                          },
                          expression: "avaliable_in"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c(
                        "q-field",
                        {
                          attrs: {
                            helper: _vm.$t(
                              "leave_it_blank_to_use_training_score"
                            )
                          }
                        },
                        [
                          _c("q-input", {
                            attrs: {
                              type: "number",
                              "float-label": _vm.$t("module_score"),
                              error: _vm.$v.module_score.$error
                            },
                            on: { input: _vm.$v.module_score.$touch },
                            model: {
                              value: _vm.module_score,
                              callback: function($$v) {
                                _vm.module_score = $$v
                              },
                              expression: "module_score"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("status")))
                      ]),
                      _c("q-btn-toggle", {
                        attrs: {
                          "toggle-color": _vm.getColorButtonStatus,
                          options: _vm.statuses
                        },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "far fa-block"
                          },
                          on: {
                            click: function($event) {
                              _vm.module_modal = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveModule()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            show: function($event) {
              return _vm.clearSelectedClass()
            },
            hide: function($event) {
              return _vm.clearSelectedClass()
            }
          },
          model: {
            value: _vm.search_classes_database_modal,
            callback: function($$v) {
              _vm.search_classes_database_modal = $$v
            },
            expression: "search_classes_database_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.search_classes_database_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("modules")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-input",
                        {
                          attrs: {
                            "float-label":
                              _vm.$t("titles") +
                              ": " +
                              _vm.$t("training") +
                              ", " +
                              _vm.$t("module"),
                            clearable: ""
                          },
                          on: {
                            clear: function($event) {
                              return _vm.clearSelectedClass()
                            }
                          },
                          model: {
                            value: _vm.search_classes_list,
                            callback: function($$v) {
                              _vm.search_classes_list = $$v
                            },
                            expression: "search_classes_list"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: {
                              "max-results": 25,
                              "min-characters": 3,
                              "value-field": function(v) {
                                return (
                                  v.id + " - " + v.group_training_module_title
                                )
                              }
                            },
                            on: {
                              search: _vm.searchClassesDataBase,
                              selected: _vm.selectClassDataBase
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm.selected_class.group_training_title !== ""
                  ? _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
                      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("training")) + ": ")
                        ]),
                        _vm._v(
                          _vm._s(_vm.selected_class.group_training_title) +
                            "\n                    "
                        )
                      ]),
                      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("module")) + ":  ")
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm.selected_class.group_training_module_title
                          ) + "\n                    "
                        )
                      ]),
                      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("content_type")) + ":  ")
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm.selected_class.group_training_module_type
                          ) + "\n                    "
                        )
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            icon: "far fa-block",
                            label: _vm.$t("cancel")
                          },
                          on: {
                            click: function($event) {
                              _vm.search_classes_database_modal = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            icon: "far fa-file-import",
                            label: _vm.$t("import"),
                            disable:
                              _vm.selected_class.group_training_module_title ===
                              ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmSelectedClass()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.removeModule()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeModule()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }